export default __webpack_public_path__ + "static/media/flying_bee.48d344fc.gif";